// BookingConfirmScreen.js
import React, { useEffect, useRef, useState } from 'react';
import globalState from '../globalstate';
import Topbar from './Topbar';
import Footer from './Footer';
import { BookingSummary } from './BookingScreen';

const BookingConfirmScreen = () => {
  const [orderSnapshot, setOrderSnapshot] = useState({});
  const hasRunRef = useRef(false);
  const [isVerticalLayout, setIsVerticalLayout] = useState(window.innerWidth < (window.innerHeight*1.75));

  useEffect(() => {
    const handleResize = () => {
      setIsVerticalLayout(window.innerWidth < window.innerHeight*1.75);
    };

    window.addEventListener('resize', handleResize);
    if (hasRunRef.current) return () => window.removeEventListener('resize', handleResize);
    hasRunRef.current = true;
    
    console.log("BookingConfirmScreen mounted.");
    console.log("Global cart before snapshot:", globalState.orderInCartMap);

    // Capture a snapshot of the current cart
    const snapshot = { ...globalState.orderInCartMap };
    console.log("Snapshot captured:", snapshot);
    setOrderSnapshot(snapshot);

    // Clear the global cart and save to localStorage
    globalState.orderInCartMap = {};
    globalState.saveStateToLocalStorage();
    console.log("Global cart after clearing:", globalState.orderInCartMap);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ position: 'relative', margin: '0 auto' }}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <Topbar />
      </div>
      <div
        style={{
          backgroundColor: '#f2f2f2',
          padding: '28px 32px',
          minHeight: 'calc(100vh - 48px)',
          boxSizing: 'border-box',
          marginTop: '56px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px',
            width: isVerticalLayout ? '300px' : '600px',
            margin: '0 auto',
          }}
        >
          <ThankYouWidget />
          {/* Pass orderSnapshot to BookingSummary */}
          <div style={{ width: isVerticalLayout ? '300px' : '600px' }}>
            <BookingSummary isDisableTap={true} orderSnapshot={orderSnapshot} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const ThankYouWidget = () => {
  return (
    <div
      style={{
        width: '100%',
        padding: '24px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="40"
          viewBox="0 0 24 24"
          width="40"
          fill="green"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15l-5-5 1.41-1.41L11 14.17l7.59-7.59L20 8l-9 9z" />
        </svg>
      </div>
      <h2 style={{ margin: '16px 0', fontSize: '20px', fontWeight: 'bold' }}>
        Thank You!
      </h2>
      <p style={{ fontSize: '16px', color: 'black' }}>
        We’ll contact you within 1 working day to confirm the booking
      </p>
    </div>
  );
};

export default BookingConfirmScreen;
